import {
  FaQuestionCircle,
  FaCode,
  FaCss3Alt,
  FaGlobe,
  FaVideo,
  FaCube,
  FaDatabase,
  FaDesktop,
  FaPaintBrush,
  FaCamera,
  FaMobileAlt,
  FaLanguage,
  FaReact,
  FaJsSquare,
  FaNodeJs,
  FaFilm,
  FaMagic,
  FaShapes,
  FaCut,
  FaPenSquare,
  FaPlay,
} from 'react-icons/fa';

// Reine Komponenten-Referenzen für flexibles Styling im JSX
const ICONS = {
  code: FaCode,
  css3: FaCss3Alt,
  globe: FaGlobe,
  video: FaVideo,
  "3d": FaCube,
  database: FaDatabase,
  desktop: FaDesktop,
  paintBrush: FaPaintBrush,
  camera: FaCamera,
  mobile: FaMobileAlt,
  language: FaLanguage,
  react: FaReact,
  javascript: FaJsSquare,
  nodejs: FaNodeJs,
  aftereffects: FaFilm,
  animation: FaMagic,
  compositing: FaCube,
  atechnik: FaShapes,
  schnitt: FaCut,
  compo: FaPenSquare,
  rendering: FaPlay,
  default: FaQuestionCircle,
};


// Farbzuordnung als Map gelöst 

export const ICON_COLORS = {
  code: "text-purple-500",
  css3: "text-orange-500",
  globe: "text-blue-500",
  video: "text-red-500",
  "3d": "text-green-500",
  database: "text-orange-50",
  desktop: "text-teal-500",
  paintBrush: "text-orange-50",
  camera: "text-purple-600",
  mobile: "text-blue-600",
  language: "text-brown-500",
  react: "text-blue-600",
  javascript: "text-orange-50",
  nodejs: "text-green-500",
  aftereffects: "text-blue-600",
  animation: "text-purple-600",
  compositing: "text-green-600",
  atechnik: "text-green-500",
  schnitt: "text-black",
  compo: "text-black",
  rendering: "text-black",
  default: "text-gray-500",
};


export default ICONS;
